import { useState } from "react";

import { useMarketIndicators } from "../../context/MarketIndicatorContext";
import "./Chat.css";
import { useRef } from "react";

const Chat = () => {
  const { sendPrompt, messages, loading, error } = useMarketIndicators();
  const lastPromptRef = useRef(null);

  //   const { messages, sendPrompt, loading, error } = useChat();
  const [input, setInput] = useState("");

  const handleSend = () => {
    if (!input.trim()) return;
    sendPrompt(input);
    lastPromptRef.current = input;

    setInput("");
  };

  return (
    <div className="chat-panel">
      <div className="chat-header">
        <h3>AI Assistant</h3>
      </div>

      <div className="chat-messages">
        {messages?.map((msg, idx) => (
          <div
            key={idx}
            className={`chat-bubble ${msg.role} ${msg.error ? "error" : ""}`}
          >
            {msg.text}
          </div>
        ))}

        {loading && (
          <div className="chat-bubble ai typing">AI is typing...</div>
        )}
      </div>

      {error && <div className="chat-error">{error}</div>}

      <div className="chat-input">
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ask something..."
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
          disabled={loading}
        />
        <button onClick={handleSend} disabled={loading}>
          Send
        </button>
      </div>
    </div>
  );
};

export default Chat;
